import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui";
import VoucherForm, { createVoucherFormDefaults } from "./VoucherForm";
import { createVoucher } from "./voucherApi";
import "./Voucher.css";

function AddVoucherPage() {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async ({ payload, error: validationError }) => {
    if (validationError) {
      setError(validationError);
      return;
    }

    setError("");
    setSaving(true);
    try {
      await createVoucher(payload);
      navigate("/voucher");
    } catch (err) {
      setError(
        err.response?.data?.message ||
          err.response?.data ||
          err.message ||
          "Failed to create voucher.",
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="voucher-page">
      <div className="voucher-form-shell">
        <div className="voucher-form-header">
          <div>
            <h1 className="page-title">Create Voucher</h1>
            <p className="page-subtitle">Create a new voucher for Taaffee.</p>
          </div>
          <Button variant="ghost" onClick={() => navigate("/voucher")}>
            Back to Vouchers
          </Button>
        </div>

        <div className="voucher-form-card">
          <VoucherForm
            mode="create"
            initialValues={createVoucherFormDefaults()}
            error={error}
            saving={saving}
            onCancel={() => navigate("/voucher")}
            onSubmit={handleSubmit}
          />
        </div>
      </div>
    </div>
  );
}

export default AddVoucherPage;
